// @flow
import window from 'window';
import fetch from 'fetch';

export const fetchEntrypoints = (path: string): JSON => {
	return fetch(`${window.location.origin}${path}`)
		.then((response) => response.json());
};